import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, EventEmitter, HostListener
  , inject, input, OnDestroy, OnInit, Output, 
  ViewChild} from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { RouterOutlet } from '@angular/router';
import { FuseAlertComponent } from '@fuse/components/alert';
import { ItmToolbarComponent } from '@itm/components/toolbar';
import { takeUntil, tap } from 'rxjs/operators';
import { ActionPRSubType, ActionType, IActions } from '../../../utilities';
import { MapComponent } from 'app/modules/admin/shared/maps.component';
import { TextAreaModule, TextBoxComponent, TextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { CacNotifyService } from 'app/modules/admin/shared/services/cac.notify.service';
import { FormsModule } from '@angular/forms';
import moment from 'moment-timezone';
import { GoogleMapEmbededComponent } from 'app/modules/admin/shared/google-map-embeded/google-map-embeded.component';
import { AggregateService, GridComponent, GridModule, GroupService, PageService } from '@syncfusion/ej2-angular-grids';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { ItmBaseComponent } from '@itm/components/itm.base.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { CoreSupplierService } from 'app/modules/admin/shared/services/core.supplier.service';
import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';

@Component({
    selector: 'supplier-sidebar',
    templateUrl: './supplier-sidebar.component.html',
    styleUrls: ['./supplier-sidebar.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      // RouterOutlet, 
      CommonModule, GridModule
      // , ItmToolbarComponent
      // , FuseAlertComponent
      , TextBoxModule, AccordionModule, DropDownListModule 
      , MatInputModule
      // , MapComponent
      , TextAreaModule, FormsModule
      // , GoogleMapEmbededComponent
    ],
    providers: [
      AggregateService
      , GroupService
      , PageService
    ],
})
export class SupplierSidebarComponent extends ItmBaseComponent implements OnInit, OnDestroy  {

  additionalHeight: number = 70;
  containerHeight: any = 0;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const innerHeight = event.target.innerHeight;
    this.containerHeight = innerHeight - this.additionalHeight;
    this.setInnerContainerHeight();
  }

  @ViewChild('grid') public grid?: GridComponent;
  @ViewChild('creditorCode', { static: false }) creditorCode: TextBoxComponent;

  @Output() fireRejectEvent = new EventEmitter<any>();
  @Output() fireApproveEvent = new EventEmitter<any>();

  originalSelectedLineItems: any;
  actionData = input<IActions>();

  actionButton = computed(() => {
    return this.actionData()?.actionButton;
  });

  supplier = computed(() => {
    return this.actionData()?.additional?.supplier;
  });

  private readonly _cacNotifyService = inject(CacNotifyService);
  private readonly _coreSupplierService = inject(CoreSupplierService);

  visibleCreditor: boolean = false;
  ActionType = ActionType;
  ActionPRSubType = ActionPRSubType;

  selectionSettings = {
    type: 'Multiple',
    mode: 'Row',
    checkboxOnly: true
  };

  urlAdapterData!: DataManager;
  public ccPlaceholder: string = "Enter Creditor Code";
  public fields: Object = { text: 'creditor_Code', value: 'creditor_Code' };
  
  constructor() {
    super();
    effect(() => {
      // this._changeDetectorRef.detectChanges();
      // console.log(this.actionData())
    })
  }

  ngOnInit(): void {
    this.containerHeight = window.innerHeight - this.additionalHeight;
    this.setInnerContainerHeight();
    
    this._cacNotifyService.sidebarOpenedStatus$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(x => {
      this.visibleCreditor = false;
      this._changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
  }

  onRowDataBound(args: any): void {
  }

  onGridDataBound(): void {
    
  }

  onApproveClick(e: any){
    if(this.visibleCreditor == false){
      this.supplier().creditorCode = '';
      this.visibleCreditor = true;

      const abn = this.supplier()?.abn;
      if (abn) {
        let composedURL = `${this._http.GET_API_URL()}core/supplier/cc/${abn}`;
        this.urlAdapterData = new DataManager({
              url: composedURL,
              headers: [{ 'Authorization': `Bearer ${this._itmUserService.getAccessTokenLocalStorage()}` }],
              adaptor: new UrlAdaptor(),
            });
      }
    }
    else {
      if(!this.supplier().creditorCode){
        this._toastr.showInfo('Creditor code is required before proceeding with approval.');
        return;
      }

      const confirmationMessage = `Are you sure you want to approve ?`;
      const confirmation = this._fuseConfirmationService.open(
        {
          title: 'Confirmation',
          message: confirmationMessage,
          panelClass: "archive-dialog-panel",
          dismissible: true,
          icon: {
            show: true,
            color: 'info'
          },
          actions: {
            confirm: {
              show: true,
              label: 'Confirm',

            },
            cancel: {
              show: true,
              label: 'Cancel'
            }
          }
        }
      );
      confirmation.afterClosed().subscribe((result) => {
        if (result === 'confirmed') {
          this.fireApproveEvent.emit({target: e, apiUrl: `cac/action/${this.actionData()?.id}/approve_pr_supplier`});
        }
      });
    }
  }

  onRejectClick(e: any){
    // console.log('onRejectClick', e)
    const confirmationMessage = `Are you sure you want to reject ?`;
    const confirmation = this._fuseConfirmationService.open(
      {
        title: 'Confirmation',
        message: confirmationMessage,
        panelClass: "archive-dialog-panel",
        dismissible: true,
        icon: {
          show: true,
          color: 'info'
        },
        actions: {
          confirm: {
            show: true,
            label: 'Confirm',

          },
          cancel: {
            show: true,
            label: 'Cancel'
          }
        }
      }
    );
    confirmation.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
        this.fireRejectEvent.emit({target: e, apiUrl: `cac/action/${this.actionData()?.id}/reject_pr_supplier`});
      }
    });
  }
}
